<template>
  <PageTemplate class="mt-n5 mt-md-n7 mt-lg-n8">
    <TeamSection title="Nossos Consultores" />
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import TeamSection from "../components/sections/TeamSection.vue";

export default {
  components: {
    PageTemplate,
    TeamSection,
  },
};
</script>
